import React from "react";
import DocumentVenteEntity from "./DocumentVenteEntity";

const BonRetourVente = () => {
    return <DocumentVenteEntity type="Bon Retour" title="Bons Retour" endpoint="BonRetourVente" />;
};

export default BonRetourVente;